// Mirrors notifyArgsSchema in packages/middleware/src/cpg/notify.runner.ts — keep the
// shape in sync: { new_docs?: number, slack_webhook_url?: string }. Both optional: no
// new_docs = plain waiting-count reminder; no webhook = the middleware environment's
// CPG_NOTIFICATION_SLACK_WEBHOOK_URL.
export function extractNewDocs(value: unknown): unknown {
  if (typeof value === 'object' && value !== null && 'new_docs' in value) {
    return (value as Record<string, unknown>).new_docs
  }
  return undefined
}

export function extractWebhookUrl(value: unknown): unknown {
  if (typeof value === 'object' && value !== null && 'slack_webhook_url' in value) {
    return (value as Record<string, unknown>).slack_webhook_url
  }
  return undefined
}

export function buildNotifyArgs(newDocs: number | undefined, webhookUrl: string): unknown {
  return {
    ...(newDocs !== undefined && { new_docs: newDocs }),
    ...(webhookUrl.trim() !== '' && { slack_webhook_url: webhookUrl.trim() }),
  }
}

export function validateNotifyArgs(value: unknown): string | null {
  if (value === undefined || value === null) return null
  if (typeof value !== 'object' || Array.isArray(value)) {
    return 'Args must be an object'
  }
  const newDocs = extractNewDocs(value)
  if (newDocs !== undefined && (!Number.isInteger(newDocs) || (newDocs as number) <= 0)) {
    return 'New documents must be a positive whole number'
  }
  const webhookUrl = extractWebhookUrl(value)
  if (webhookUrl !== undefined) {
    if (typeof webhookUrl !== 'string' || !/^https?:\/\/\S+$/.test(webhookUrl)) {
      return 'Webhook URL must be a valid http(s) URL'
    }
  }
  return null
}
